<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VscDfV/tc-custom/9780544177642.jpg?1736886759723" alt="This image is the cover for the book Easy Slow Cooker Recipes, Betty Crocker Cooking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Easy Slow Cooker Recipes, Betty Crocker Cooking
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Simple, scrumptious slow cooker meals are a cinch with this cookbook from Betty Crocker.</b></p><p>A slow cooker makes it easy to get family meals on the table fast—just get everything started before you leave for the day, then come home to a fully cooked dinner! Inside, you'll find a quick guide to understanding your slow cooker, plus over 20 proven slow cooker recipes for comforting soups, stews and main dishes, including zesty international options and healthy vegetarian choices.</p><p>For more great ideas visit bettycrocker.com</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Betty Crocker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?461d9a46